import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../api/axios';
import { canFiscalRelay, fiscalForward } from '../utils/printService';

// Fiskal satış növbə bağlı olduğu üçün alınmayanda (backend utils/shiftGuard.js → shift_closed)
// harada olursa olsun «Shift aç» pəncərəsi çıxır. api/axios.js 'fiscal-shift-closed' hadisəsini göndərir.

const runCashbox = async (action) => {
    if (canFiscalRelay()) {
        const prep = await api.post('/cashbox/prepare', { action });
        const fwd = await fiscalForward(prep.data.relay);
        return api.post('/cashbox/complete', { action, raw: fwd.raw, status: fwd.status });
    }
    return api.post(`/cashbox/${action}`);
};

const TEXT = {
    closed: {
        title: 'Kassa növbəsi bağlıdır',
        body: 'Kassa aparatında növbə bağlıdır. Ola bilsin növbə 24 saat bağlanmadığı üçün aparat onu özü bağlayıb. Satışın fiskala getməsi üçün növbəni açın.',
        button: 'Shift aç',
    },
    expired: {
        title: 'Növbə 24 saatdan çoxdur açıqdır',
        body: 'Kassa aparatı yeni satış qəbul etmir, çünki növbə 24 saatdan çoxdur bağlanmayıb. Növbəni bağlayıb (Z hesabat) yenidən açın.',
        button: 'Z hesabat et və Shift aç',
    },
};

export default function ShiftClosedPrompt() {
    const [reason, setReason] = useState(null);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        const onClosed = (e) => setReason(e.detail?.reason === 'expired' ? 'expired' : 'closed');
        window.addEventListener('fiscal-shift-closed', onClosed);
        return () => window.removeEventListener('fiscal-shift-closed', onClosed);
    }, []);

    if (!reason) return null;
    const text = TEXT[reason];

    const openShift = async () => {
        setBusy(true);
        try {
            if (reason === 'expired') {
                // Z alınmasa da (aparat artıq bağlayıbsa) açmağa davam et
                await runCashbox('z-report').catch(() => {});
            }
            await runCashbox('open-shift');
            toast.success('Növbə açıldı. Əməliyyatı yenidən edin.');
            window.dispatchEvent(new Event('app-resync'));
            setReason(null);
        } catch (err) {
            toast.error(err.response?.data?.msg || err.message || 'Növbə açılmadı.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/40 p-4">
            <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
                <div className="mb-2 text-3xl">🧾</div>
                <h3 className="mb-2 text-lg font-bold text-gray-800">{text.title}</h3>
                <p className="mb-5 text-sm leading-relaxed text-gray-600">{text.body}</p>
                <div className="flex gap-3">
                    <button
                        type="button"
                        onClick={() => setReason(null)}
                        disabled={busy}
                        className="flex-1 rounded-xl border border-gray-200 py-2.5 text-sm font-semibold text-gray-500 hover:bg-gray-50 disabled:opacity-50"
                    >
                        Bağla
                    </button>
                    <button
                        type="button"
                        onClick={openShift}
                        disabled={busy}
                        className="flex-1 rounded-xl bg-emerald-600 py-2.5 text-sm font-bold text-white hover:bg-emerald-700 disabled:opacity-60"
                    >
                        {busy ? 'Gözləyin...' : text.button}
                    </button>
                </div>
            </div>
        </div>
    );
}
